import React, { useCallback, useEffect, useState } from "react";
import { TextField, Button, Box, Typography } from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useNavigate, useParams } from "react-router-dom";
import HttpService from "../../Hooks/Https-services";
import { APIRoutes, PageRoutes } from "../../Utils/constant";
import { LoadingButton } from "@mui/lab";

// Validation Schema
const validationSchema = Yup.object({
  url: Yup.string()
    .required("URL is required")
    .matches(/\.ts$/, "URL must end with .ts"),
  duration: Yup.number()
    .required("Duration is required")
    .positive("Duration must be a positive number")
    .typeError("Duration must be a number"),
});

const AddBumperVideo = () => {
  const { id }: any = useParams();
  const [initialValues, setInitialValues] = useState({
    url: "",
    duration: "",
  });
  const navigate = useNavigate();
  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validateOnMount: true,
    validationSchema,
    onSubmit: async (values) => {
      try {
        const payload = {
          bumper_url: values.url,
          duration: values.duration,
        };
        if (id !== "0") {
          const res = await HttpService.post(
            APIRoutes.EditBumper.replace(":id", id),
            payload
          );
          navigate(PageRoutes.SettingBumperVideo);
        } else {
          const res = await HttpService.post(APIRoutes.CreateBumper, payload);
          navigate(PageRoutes.SettingBumperVideo);
        }
      } catch (error) {}
    },
  });
  const GetBumperVideoByID = useCallback(async () => {
    try {
      if (id) {
        const res = await HttpService.get(
          APIRoutes.GetBumpersByID.replace(":id", id)
        );
        const data = res.data.data;
        if (data) {
          setInitialValues({
            ...initialValues,
            url: data.bumper_url,
            duration: data.duration,
          });
        }
      }
    } catch (error) {}
  }, [id]);
  useEffect(() => {
    GetBumperVideoByID();
  }, [GetBumperVideoByID]);
  return (
    <Box
      component="form"
      onSubmit={formik.handleSubmit}
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 2,
        margin: "auto",
        maxWidth: 600,
        mt: 4,
        textAlign: "center",
      }}
    >
      <Typography variant="h5" sx={{ fontWeight: 600 }}>
        Create Bumper Video
      </Typography>
      {/* URL Field */}
      <TextField
        label="URL"
        variant="outlined"
        name="url"
        size="small"
        value={formik.values.url}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.touched.url && Boolean(formik.errors.url)}
        helperText={formik.touched.url && formik.errors.url}
        fullWidth
      />

      {/* Duration Field */}
      <TextField
        label="Duration"
        variant="outlined"
        size="small"
        name="duration"
        value={formik.values.duration}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        error={formik.touched.duration && Boolean(formik.errors.duration)}
        helperText={formik.touched.duration && formik.errors.duration}
        fullWidth
      />

      {/* Submit Button */}
      <LoadingButton
        loading={formik.isSubmitting}
        type="submit"
        variant="contained"
        color="primary"
        disabled={!formik.isValid || formik.isSubmitting}
      >
        Submit
      </LoadingButton>
    </Box>
  );
};

export default AddBumperVideo;
